export default {
    name: 'dealers',
    component: () => import(/* webpackChunkName: "dealers-Layout" */ '@/modules/dealers/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.dealers.index',
            component: () => import(/* webpackChunkName: "dealers-index" */ '@/modules/dealers/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.dealers.create',
            component: () => import(/* webpackChunkName: "dealers-create" */ '@/modules/dealers/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.dealers.edit',
            component: () => import(/* webpackChunkName: "dealers-edit" */ '@/modules/dealers/views/Edit'),
        },
    ]
}